import React, { useState } from 'react';
import Link from 'next/link';
import { Popover, Whisper, Button } from 'rsuite';
import { useRouter } from 'next/router';
import Styles from  './styles.js';

const LandingPageNav = () => {
  const [changeHeader, setHeader] = useState(false);

  const changeHeaderEffect = () => {
    if (window.scrollY >= 81) {
      setHeader(true);
    } else {
      setHeader(false);
    }
  };
  React.useEffect(() => {
    // window is accessible here.
    window.addEventListener('scroll', changeHeaderEffect);
  }, []);

  const [show, setShow] = useState({
    showMenu: 'navbar  order-0 lg:order-2 ',
    closeMenu: 'flex-lg-hidden ',
  });

  const [mobileDropdown, setMobileDropdown] = useState('');
  const router = useRouter();

  return (
    <>
      <header
        // id="header"
        id={changeHeader ? 'headerchanged' : 'header'}
        className="shadow-none fixed top-0  left-0 right-0 bottom-0  flex items-center">
        {/* <div className="  d-flex align-items-center "> */}
        <div className="lg:container mx-auto w-full flex items-center px-0 sm:px-2">
          <div className="logo order-2   pl-12  lg:pl-0 lg:order-1 lg:mr-auto mx-auto lg:mx-0    lg:ml-0">
            <Link href="/renters">
              <a>
                <img
                  loading="lazy"
                  src="/static/images/landingPages/logo.png"
                  className={changeHeader ? 'scrollEffect h-8 w-full ' : ' logoImg h-8 w-full'}
                  alt="Logo picture"
                />
              </a>
            </Link>
          </div>

          <nav className={`${show.showMenu}  flex items-center pr-0`} id="navbar">
            <ul style={{ fontFamily: 'Josefin Sans' }} className={show.closeMenu}>
              <li>
                <Link href="/renters">
                  <a
                    className={
                      router.pathname == '/'
                        ? 'navBorder nav-link linkSize scrollto active lg:px-0 pb-1'
                        : 'nav-link linkSize scrollto pb-1 '
                    }>
                    Home
                  </a>
                </Link>
              </li>
              <li>
                <Link href="for-renters" className="nav-link scrollto">
                  <a
                    className={
                      router.pathname == '/for-renters'
                        ? 'navBorder nav-link linkSize scrollto active px-0 lg:ml-8 pb-1'
                        : 'nav-link linkSize scrollto pb-1 lg:ml-8'
                    }>
                    For Renters
                  </a>
                </Link>
              </li>
              <li>
                <Link href="find-a-soulroom" className="nav-link scrollto">
                  <a
                    className={
                      router.pathname == '/find-a-soulroom'
                        ? 'navBorder nav-link linkSize scrollto active px-0 lg:ml-8 pb-1 '
                        : 'nav-link linkSize scrollto pb-1 lg:ml-8'
                    }>
                    Find Properties
                  </a>
                </Link>
              </li>
            </ul>

            {/* HAMBURGER ICON  */}
            <i
              className="bi  bi-list mobile-nav-toggle showmenu "
              onClick={() => {
                setShow({
                  showMenu: 'navbar  order-0 lg:order-2  navbar-mobile',
                  closeMenu: 'block mobile-nav-toggle',
                });
              }}>
              {' '}
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="40px"
                height="40px"
                data-ux="IconHamburger"
                className="x-el x-el-svg p-6 ">
                <path
                  fillRule="evenodd"
                  d="M19.248 7.5H4.752A.751.751 0 0 1 
                  4 6.75c0-.414.337-.75.752-.75h14.496a.75.75 
                  0 1 1 0 1.5m0
                   5.423H4.752a.75.75 0 
                   0 1 0-1.5h14.496a.75.75 0 1 1 0 
                   1.5m0 5.423H4.752a.75.75 0 1 1 
                   0-1.5h14.496a.75.75 0 1 1 0 1.5"></path>
              </svg>
            </i>

            {/* CLOSE ICON FOR MOBILE SCREENS  */}
            {/* <i
              className={show.closeMenu}
              onClick={() => {
                setShow({
                  showMenu: 'navbar  order-0 lg:order-2 ',
                  closeMenu: 'lg:flex hidden',
                });
              }}>
              <svg
                viewBox="0 0 24 24"
                fill="white"
                width="35px"
                height="40px"
                data-ux="CloseIcon"
                data-edit-interactive="true"
                data-close="true"
                className=" d-block d-lg-none fx-el x-el-svg ">
                <path
                  fillRule="evenodd"
                  d="M19.219 5.22a.75.75 0 0 0-1.061 0l-5.939 5.939-5.939-5.94a.75.75 
                  0 1 0-1.061 1.062l5.939 5.939-5.939 5.939a.752.752 0 0 0 0 1.06.752.752 0 0 0 1.061 
                  0l5.939-5.938 5.939 5.939a.75.75 0 1 0 1.061-1.061l-5.939-5.94 
                  5.939-5.938a.75.75 0 0 0 0-1.061"></path>
              </svg>
            </i> */}
          </nav>
          {/* <!-- .navbar --> */}

          {/* ICONS  */}
          {/* <div className="header-social-links m-0 order-3 order-lg-3 d-flex align-items-center ">
            
              <div className={'p-6 d-none d-sm-none d-lg-block'} style={{ color: 'black' }}>
                |
              </div>
        
              <Link className="nav-link scrollto" href="/login">
                <a>
                  <svg
                    viewBox="0 0 24 24"
                    fill="black"
                    width="40px"
                    height="40px"
                    data-ux="UtilitiesMenuIcon"
                    data-typography="NavAlpha"
                    className="x-el x-el-svg p-6 d-block">
                    <path
                      fillRule="evenodd"
                      d="M5.643 19.241a.782.782 0 0 1-.634-.889c.317-2.142 
                1.62-4.188 3.525-5.244l.459-.254-.39-.352a4.89 4.89 
                0 0 1-.797-6.327 4.747 4.747 0 0 1 2.752-2.003 
                4.894 4.894 0 0 1 6.092 5.72c-.211 1.042-.802 
                1.97-1.59 2.683l-.308.28.459.253c1.876 1.04 3.185 
                3.131 3.53 5.26a.765.765 0 
                0 1-.742.883c-.367.005-.697-.25-.753-.613-.52-3.384-4.067-6.087-7.702-4.324-1.628.79-2.714 
                2.511-3.014 4.313a.76.76 0 0 1-.887.614zm2.873-10.36a3.36 3.36 0 0 0 3.356 3.355A3.36 
                3.36 0 0 0 15.23 8.88a3.361 3.361 0 0 0-3.358-3.357A3.36 3.36 0 0 0 8.516 8.88z"></path>
                  </svg>
                </a>
              </Link>

       
            </div> */}
        </div>
        {/* </div> */}
      </header>
      <Styles/>
    </>
  );
};

export default LandingPageNav;
